<template>
    <div>
        <b-form-group
            v-if="!is_walkthrough"
            label="Caption"
            label-for="caption"
        >
            <TipTap
                v-model="editable_content.question"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                @input="setContent('question', $event)"
            />
        </b-form-group>
        <b-form-group
            label="Media"
            label-for="media"
        >

            <b-form-invalid-feedback
                class="mb-2"
                :state="validating && (!editable_content.media || editable_content.media && !editable_content.media.src) ? false : null"
            >
                Image is required
            </b-form-invalid-feedback>
            <b-dropdown
                size="sm"
                variant="outline-primary"
                dropup
                right
            >
                <template #button-content>
                    <font-awesome-icon :icon="['fad', 'plus-square']" />
                    Add Media
                </template>
                <b-dropdown-item @click.prevent="addExistingRelatedMedia">
                    <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width />
                    Add SBP Media
                </b-dropdown-item>
            </b-dropdown>
        </b-form-group>
        <SbpMedia
            :media="editable_content.media"
            :key="editable_content.media.media_id"
            @update="update"
            @removeImage="removeImage"
        />
        <add-related-media-modal
            v-model="show_add_related_media_modal"
            @link="linkRelatedMediaItem"
            @hide="show_add_related_media_modal = false"
        />
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import {mapState} from 'vuex'
import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'
import SbpMedia from '@/components/media/SbpMedia'

export default {
    data: () => ({
        editable_content: {
            media: {}
        },
        show_add_related_media_modal: false,
    }),
    props: [
        'question',
        'is_walkthrough',
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap'),
        AddRelatedMediaModal,
        SbpMedia
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        }),
        format() {
            if (!this.editable_content.media.file_ext) {
                return false
            }
            if (this.image_extensions.includes(this.editable_content.media.file_ext.toLowerCase)) {
                return 'image'
            }
            if (this.video_extensions.includes(this.editable_content.media.file_ext.toLowerCase)) {
                return 'video'
            }
            if (this.audio_extensions.includes(this.editable_content.media.file_ext.toLowerCase)) {
                return 'audio'
            }
        }
    },
    watch: {
        question: {
            handler(question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler(editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        removeImage() {
            this.$swal({
                html: 'Are you sure you want remove this media item?',
                showCancelButton: true,
                confirmButtonText: 'Remove',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.editable_content.media = {};
                }
            })
        },
        resetMedia() {
            this.$set(this.editable_content, 'media', {});
        },
        update(media) {
            let mediaClone = Object.assign({}, this.editable_content.media)
            if (media.merlin_id) {
                let merlinId = parseInt(media.merlin_id)
                mediaClone.merlin_id = !isNaN(merlinId) ? merlinId : null
                mediaClone.media_id = !isNaN(merlinId) ? merlinId : null
            } else if (media.related_media_id) {
                let mediaId = parseInt(media.related_media_id)
                mediaClone.related_media_id = !isNaN(mediaId) ? mediaId : null
                mediaClone.media_id = !isNaN(mediaId) ? mediaId : null
            }
            mediaClone.type = media.type
            mediaClone.src = media.src
            mediaClone.alt = media.alt
            mediaClone.credit = media.credit
            mediaClone.description = media.description
            mediaClone.caption = media.caption
            mediaClone.name = media.name ? media.name : (media.title ? media.title : '')

            // If there were new properties added, re-setting the media field will ensure Vue reacts to them.
            this.$set(this.editable_content, 'media', mediaClone)
        },
        linkRelatedMediaItem(item) {
            this.resetMedia();
            this.editable_content.media.related_media_id = item.id
            this.editable_content.media.media_id = item.id
            this.editable_content.media.src = item.url
            this.editable_content.media.type = item.type
            this.editable_content.media.alt = item.alt
            this.editable_content.media.credit = item.credit
            this.editable_content.media.description = item.description
            this.editable_content.media.caption = item.caption
            this.editable_content.media.title = item.title
            this.editable_content.media.splash_url = item.splash_url

            this.show_add_related_media_modal = false;
        },
        addExistingRelatedMedia() {
            if (
                this.editable_content.image &&
                this.editable_content.image.src
            ) {
                this.$swal({
                    html: 'Are you sure you want select a different image?',
                    showCancelButton: true,
                    confirmButtonText: 'Select Different Image',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.show_add_related_media_modal = true
                    }
                })
            } else {
                this.show_add_related_media_modal = true;
            }
        },
        setContent(field, value) {
            this.$set(this.editable_content, field, value)
        }
    },
}
</script>
